import React from "react"
import { useTranslation, withTranslation } from 'react-i18next';
import { Grid } from '@mui/material/';
import SETTINGS from './../../utils/constants';

const Footer=()=>{
  const {t} = useTranslation()
  return(
    <Grid container sx={{boxShadow: 3, backgroundColor: SETTINGS.PRIMARY_COLOR}}>
      <Grid item xs={12}  className="center-item">    
        <h4>
          {t('footer.copyright')}
        </h4>
      </Grid>
    </Grid>
  )
}

export default withTranslation()(Footer)